import {
  ACCENT_TEXT,
  DISPLAY,
  GROUND,
  INK,
  LABEL_CLS,
  mix,
} from "./theme";
import { Grain, SectionMarker } from "./primitives";

export type Stat = {
  /** Short headline value — a word ("Yours") or figure ("4 weeks"). */
  value: string;
  label: string;
  description: string;
};

/**
 * Editorial stat band — a row of proof stats over the cream ground, each
 * a big display value + uppercase label + supporting line, separated by
 * hairline top borders in the house style. Optional section marker.
 */
export function StatStrip({
  stats,
  section,
  label,
}: {
  stats: Stat[];
  section?: string;
  label?: string;
}) {
  const cols =
    stats.length >= 4
      ? "md:grid-cols-4"
      : stats.length === 3
        ? "md:grid-cols-3"
        : "md:grid-cols-2";

  return (
    <section
      className="relative overflow-hidden"
      style={{ backgroundColor: GROUND, color: INK }}
    >
      <Grain opacity={0.45} />
      <div className="relative z-10 mx-auto max-w-screen-xl px-5 py-14 sm:px-6 sm:py-16 md:px-14 md:py-20">
        {section && label && (
          <div className="mb-10">
            <SectionMarker section={section} label={label} />
          </div>
        )}
        <dl className={`grid grid-cols-1 gap-x-12 gap-y-10 sm:grid-cols-2 ${cols}`}>
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="border-t pt-5"
              style={{ borderTopColor: mix("--theme-ink", 18) }}
            >
              <dt
                style={{ ...DISPLAY, color: ACCENT_TEXT }}
                className="text-[2.4rem] font-semibold leading-[1] tracking-[-0.02em] md:text-[2.75rem]"
              >
                {stat.value}
              </dt>
              <p
                className={`mt-3 ${LABEL_CLS}`}
                style={{ color: mix("--theme-ink", 80) }}
              >
                {stat.label}
              </p>
              <dd
                className="mt-3 text-[0.95rem] leading-[1.55]"
                style={{ color: mix("--theme-ink", 88) }}
              >
                {stat.description}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
